<lib-error-ui error="Not found" [status]="404">
  <p><a routerLink="/">Go home</a>! There is nothing to see here.</p>
</lib-error-ui>
